import { Setting, Settings, Space, Tag, TagMap, UserType } from "../types";

import { combineReducers } from "redux";
import rootReducer from "./reducers";

export const SET_USER = "set_user";
export const DELETE_USER = "delete_user";
export const SET_SETTINGS = "set_settings";
export const ADD_SETTINGS = "add_settings";
export const SET_SPACES = "set_spaces";
export const FILTER_SPACE = "filter_space";
export const CHECK_SPACE = "check_space";
export const CHECK_ALL_SPACE = "check_all_space";
export const DELETE_SETTINGS = "delete_settings";
export const DELETE_SETTING = "delete_setting";
export const DELETE_SPACES = "delete_spaces";
export const ADD_SPACE_TAG = "add_space_tag";
export const DELETE_SPACE_TAG = "delete_space_tag";
export const SET_SAFE_CAPACITY = "set_safe_capacity";
export const SET_TARGET_CAPACITY = "set_target_capacity";
export const SET_LEGAL_CAPACITY = "set_legal_capacity";
export const ADD_TAGS = "add_tags";
export const UPDATE_TAGS = "update_tags";
export const DELETE_ALL_TAGS = "delete_all_tags";
export const DELETE_TAG = "delete_tag";
export const ADD_TAG = "add_tag";
export const SELECT_TAG = "select_tag";
export const UNSELECT_TAG = "unselect_tag";
export const DISABLE_TAG = "disable_tag";
export const ENABLE_TAG = "enable_tag";
export const SET_TAG_NUMBER = "set_tag_number";
export const SET_REPORTS = "set_reports";
export const DELETE_REPORTS = "delete_reports";

interface SetUserAction {
  type: typeof SET_USER;
  payload: UserType;
}

interface DeleteUserAction {
  type: typeof DELETE_USER;
}

interface SetSettingsAction {
  type: typeof SET_SETTINGS;
  payload: Settings;
}

interface AddSettingsAction {
  type: typeof ADD_SETTINGS;
  payload: Setting;
}

interface DeleteSettingAction {
  type: typeof DELETE_SETTING;
  payload: string;
}

interface DeleteSettingsAction {
  type: typeof DELETE_SETTINGS;
}

interface SetSpacesAction {
  type: typeof SET_SPACES;
  payload: Space[];
}

interface FilterSpaceAction {
  type: typeof FILTER_SPACE;
  payload: {
    id: string;
    filtered: boolean;
  };
}

interface CheckSpaceAction {
  type: typeof CHECK_SPACE;
  payload: {
    id: string;
    selected: boolean;
  };
}

interface CheckAllSpacesAction {
  type: typeof CHECK_ALL_SPACE;
  payload: boolean;
}

interface DeleteSpacesAction {
  type: typeof DELETE_SPACES;
}

interface AddSpaceTagAction {
  type: typeof ADD_SPACE_TAG;
  payload: {
    id: string;
    tag: string;
  };
}

interface DeleteSpaceTagAction {
  type: typeof DELETE_SPACE_TAG;
  payload: {
    id: string;
    tag: string;
  };
}

interface SetSafeSpaceCapacityAction {
  type: typeof SET_SAFE_CAPACITY;
  payload: {
    id: string;
    capacity: number;
  };
}

interface SetTargetCapacityAction {
  type: typeof SET_TARGET_CAPACITY;
  payload: {
    id: string;
    capacity: number;
  };
}

interface SetLegalCapacityAction {
  type: typeof SET_LEGAL_CAPACITY;
  payload: {
    id: string;
    capacity: number;
  };
}

interface AddTagsAction {
  type: typeof ADD_TAGS;
  payload: TagMap;
}

interface UpdateTagsAction {
  type: typeof UPDATE_TAGS;
  payload: TagMap;
}

interface AddTagAction {
  type: typeof ADD_TAG;
  payload: {
    id: string;
    tag: Tag;
  };
}

interface UnselectTagAction {
  type: typeof UNSELECT_TAG;
  payload: string;
}

interface SelectTagAction {
  type: typeof SELECT_TAG;
  payload: string;
}

interface DisableTagAction {
  type: typeof DISABLE_TAG;
  payload: string;
}

interface EnableTagAction {
  type: typeof ENABLE_TAG;
  payload: string;
}

interface SetTagNumberAction {
  type: typeof SET_TAG_NUMBER;
  payload: {
    id: string;
    number: number;
  };
}

interface DeleteTagAction {
  type: typeof DELETE_TAG;
  payload: string;
}

interface DeleteTagsAction {
  type: typeof DELETE_ALL_TAGS;
}
interface SetReportssAction {
  type: typeof SET_REPORTS;
  payload: Space[];
}

interface DeleteReportssAction {
  type: typeof DELETE_REPORTS;
}

export type UserAction = SetUserAction | DeleteUserAction;

export type SettingsAction =
  | SetSettingsAction
  | AddSettingsAction
  | DeleteSettingsAction
  | DeleteSettingAction;

export type TagsAction =
  | AddTagsAction
  | UpdateTagsAction
  | DeleteTagAction
  | DeleteTagsAction
  | AddTagAction
  | DisableTagAction
  | EnableTagAction
  | SetTagNumberAction
  | SelectTagAction
  | UnselectTagAction;

export type SpacesAction =
  | SetSpacesAction
  | DeleteSpacesAction
  | CheckSpaceAction
  | CheckAllSpacesAction
  | FilterSpaceAction
  | AddSpaceTagAction
  | DeleteSpaceTagAction
  | SetSafeSpaceCapacityAction
  | SetTargetCapacityAction
  | SetLegalCapacityAction;

export type ReportsAction = SetReportssAction | DeleteReportssAction;

const combined = combineReducers(rootReducer);

export type RootState = ReturnType<typeof combined>;
